import { makeElement } from './helper';
import { setLinkListeners, showSetupMenu, unwrap } from './Links';

export default class InlineLink {
  /**
   * Class name for term-tag
   *
   * @type {string}
   */
  static get CSS() {
    return 'ce-inline-link';
  }

  constructor({ api, config }) {
    this.api = api;

    this.config = config;

    this.button = null;

    this.tag = 'A';
    this.fakeTag = 'SPAN';

    /**
     * CSS classes
     */
    this.iconClasses = {
      base: this.api.styles.inlineToolButton,
      active: this.api.styles.inlineToolButtonActive,
    };
  }

  render() {
    this.button = document.createElement('button');
    this.button.type = 'button';
    this.button.classList.add(this.iconClasses.base);
    this.button.classList.add('inline-link');
    this.button.innerHTML = this.toolboxIcon;

    return this.button;
  }

  /**
   * Wrap/Unwrap selected fragment
   *
   * @param {Range} range - selected fragment
   */
  surround(range) {
    if (!range) {
      return;
    }

    const termWrapper = this.api.selection.findParentTag(this.tag, InlineLink.CSS);

    /**
     * If start or end of selection is in the highlighted block
     */
    if (termWrapper) {
      unwrap(this.api, termWrapper);
    } else {
      this.wrap(range);
    }
  }

  wrap(range) {
    const content = range.extractContents();
    const fakeLink = makeElement(this.fakeTag, InlineLink.CSS);
    fakeLink.classList.add('fake-link');
    fakeLink.appendChild(content);

    range.insertNode(fakeLink);

    this.api.selection.expandToTag(fakeLink);

    showSetupMenu(fakeLink, {
      config: this.config,
      fillLink: false,
      removeCallback: () => {
        const termWrapper = this.api.selection.findParentTag(this.fakeTag, InlineLink.CSS) || fakeLink;

        if (termWrapper) {
          unwrap(this.api, termWrapper, true);
          fakeLink.classList.remove('fake-link');
        }
      },
      confirmCallback: (url) => {
        const setupMenu = document.querySelector('.ce-link-setup-menu');
        if (setupMenu) {
          setupMenu.remove();
        }
        const termWrapper = this.api.selection.findParentTag(this.fakeTag, InlineLink.CSS);
        const link = makeElement(this.tag, InlineLink.CSS);
        link.href = url;
        link.target = '_blank';
        while (fakeLink.firstChild) {
          link.appendChild(fakeLink.firstChild);
        }

        setLinkListeners(link);

        if (termWrapper) {
          while (termWrapper.firstChild) {
            link.appendChild(termWrapper.firstChild);
          }
          termWrapper.parentNode.replaceChild(link, termWrapper);
        } else {
          range.insertNode(link);
        }

        this.api.selection.expandToTag(link);

        if (fakeLink && fakeLink.parentNode) {
          fakeLink.parentNode.removeChild(fakeLink);
        }

        window.getSelection().removeAllRanges();
      },
    });

    document.querySelector('.ce-inline-toolbar').classList.remove('ce-inline-toolbar--showed');
  }

  /**
   * Check and change Term's state for current selection
   */
  checkState() {
    const termTag = this.api.selection.findParentTag(this.tag, InlineLink.CSS);

    this.button.classList.toggle(this.iconClasses.active, !!termTag);
  }

  /**
   * Specifies Tool as Inline Toolbar Tool
   *
   * @return {boolean}
   */
  static get isInline() {
    return true;
  }

  /**
   * Get Tool icon's SVG
   * @return {string}
   */
  // eslint-disable-next-line class-methods-use-this
  get toolboxIcon() {
    return `<svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z" fill="#000000"/>
    </svg>`;
  }

  /**
   * Sanitizer rule
   * @return {{span: {class: string}}}
   */
  static get sanitize() {
    return {
      code: {
        class: InlineLink.CSS,
      },
    };
  }
}
